function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   float: right;\n   background-color: ", ";\n   color: ", ";\n   padding: 0.5rem 1.5rem;\n   border-color: ", ";\n   font-size: 0.8rem;\n   cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import axios from 'axios';
import { TfnrAuthContext } from './TfnrAuthContext';
import { LoadingOverlay } from '../../layout/LoadingOverlay';
import { FormikBasicField } from '../../formik/FormikBasicField';
var LoginBtn = styled.button(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.semanticColors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.semanticColors.primary;
});

var createLoginFormSubmitHandler = function createLoginFormSubmitHandler(_ref4) {
  var setViewInfo = _ref4.setViewInfo,
      setLoginTime = _ref4.setLoginTime,
      setIsLoading = _ref4.setIsLoading,
      tfnrApiUrl = _ref4.tfnrApiUrl;
  return function (_ref5) {
    var user = _ref5.user,
        pass = _ref5.pass,
        agreeTerms = _ref5.agreeTerms;
    setIsLoading(true);
    axios.post("".concat(tfnrApiUrl, "/sec/session/open"), {
      password: pass,
      usrName: user,
      withPerm: true
    }).then(function (res) {
      var sessOverrideKey = res.data.sessOverrideKey;

      if (sessOverrideKey) {
        return axios.post("".concat(tfnrApiUrl, "/sec/session/open"), {
          password: pass,
          usrName: user,
          withPerm: true,
          sessOverrideKey: sessOverrideKey
        });
      }

      return res;
    }).then(function (res) {
      if (res.data.errList) {
        alert(res.data.errList[0].errMsg);
      } else {
        var allData = _objectSpread({
          userId: user.toUpperCase()
        }, res.data);

        setViewInfo(allData);
        localStorage.setItem('view_info', JSON.stringify(allData));
        var loginTime = Date.now();
        setLoginTime(loginTime);
        localStorage.setItem('loginTime', JSON.stringify(loginTime));
        localStorage.setItem('hasAgreedTerms', JSON.stringify(agreeTerms));
      }
    }).catch(function () {
      return alert('Error');
    }).finally(function () {
      return setIsLoading(false);
    });
  };
};

var validateLoginForm = function validateLoginForm(_ref6) {
  var user = _ref6.user,
      pass = _ref6.pass;
  var errors = {};

  if (user === '') {
    errors.user = 'Username is required';
  }

  if (pass === '') {
    errors.pass = 'Password is required';
  }

  return errors;
};

var TfnrLoginForm = function TfnrLoginForm() {
  var _useContext = useContext(TfnrAuthContext),
      setViewInfo = _useContext.setViewInfo,
      setLoginTime = _useContext.setLoginTime,
      tfnrApiUrl = _useContext.tfnrApiUrl;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var handleSubmit = createLoginFormSubmitHandler({
    setViewInfo: setViewInfo,
    setLoginTime: setLoginTime,
    setIsLoading: setIsLoading,
    tfnrApiUrl: tfnrApiUrl
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/React.createElement(LoadingOverlay, null), /*#__PURE__*/React.createElement(Formik, {
    onSubmit: handleSubmit,
    initialValues: {
      user: '',
      pass: ''
    },
    validate: validateLoginForm
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(FormikBasicField, {
    name: "user",
    label: "Username",
    autoComplete: true
  }), /*#__PURE__*/React.createElement(FormikBasicField, {
    name: "pass",
    label: "Password",
    type: "password"
  }), /*#__PURE__*/React.createElement(LoginBtn, {
    type: "submit"
  }, "Log In"))));
};

export { TfnrLoginForm };